import React from 'react';
import { Eyebrow, Lede, PrimaryLink, GhostLink } from './primitives';
import { LICENSING_MAILTO_SHORT } from './contact';

const FACTS = [
  'Single-tenant',
  'Your cloud or on-prem',
  'White-label',
  'Bring your own models',
  'Source or container license',
];

export const LicensingHero = () => (
  <div className="relative overflow-hidden pt-20 pb-4">
    {/* ambient wash, matching the home hero's treatment */}
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-x-0 -bottom-2/5 h-[70%] bg-[radial-gradient(60%_100%_at_30%_0%,rgba(34,211,238,0.12),transparent_70%)]"
    />
    <div className="relative z-10 mx-auto grid w-full max-w-6xl gap-5 px-6">
      <div className="grid max-w-[74ch] gap-5">
        <Eyebrow>Katbot Licensing · Single-tenant deployment</Eyebrow>
        <h1 className="m-0 text-4xl font-extrabold leading-[1.12] tracking-tight text-white sm:text-5xl lg:text-6xl">
          Run your own trading
          <br />
          intelligence platform.
        </h1>
        <Lede className="!max-w-[68ch]">
          Katbot is the agentic research, recommendation, and execution engine behind katbot.ai.
          License it, deploy it inside your own cloud account, and put your name on it. Your
          infrastructure. Your keys. Your builder code. Your users.
        </Lede>
        <div className="mt-2.5 flex flex-wrap gap-3.5">
          <PrimaryLink href={LICENSING_MAILTO_SHORT}>Email us for details</PrimaryLink>
          <GhostLink href="#included">See what&rsquo;s included</GhostLink>
        </div>
        <div className="mt-6 flex flex-wrap gap-2.5 font-mono text-[0.76rem] text-gray-400">
          {FACTS.map((fact) => (
            <span key={fact} className="rounded-full border border-gray-700/60 px-3.5 py-1.5">
              {fact}
            </span>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default LicensingHero;
